<template>
  <div class="api-auth">
    <navigation>资料补充</navigation>
    <!-- ocr -->
    <ocr v-if="showOcr" :status="ocrStatus" ref="ocrRef"></ocr>
    <template v-if="stepType !== 'OCR'" >
      <!-- 基础信息 -->
      <section class="title">
        <h1>基础信息</h1>
        <h2>仅用于信用与额度评估，请依照您的实际情况填写，确保信息真实可靠。</h2>
      </section>
      <main>
        <!-- 表单 -->
        <form
          ref="form"
          class="form"
        >
          <div
            v-for="(col,index) in cData"
            :key="col.colChineseName+index"
          >
            <div class="card-title">
              <img :src="col.colIcon">
              <span>{{col.colChineseName}}</span>
            </div>
            <div class="card-panel">
              <!-- v-show="!(
                (['f13','f15'].includes(field.fieldId) && ['H','G'].includes(form['f5']) && field.elementType === 'TEXTAREA')
                || (['f16','f17'].includes(field.fieldId) && ['H','G'].includes(form['f5']) && field.elementType === 'SELECT') 
                || (['f18'].includes(field.fieldId) && ['H','G'].includes(form['f5'])) && field.elementType === 'AREA')
              " -->
              <div
                v-for="(field,index) in col.fieldDefs"
                :key="field.chineseName+index"
              >
                <template v-if="isShow(field, col.fieldDefs) ">
                  <!-- 无业隐藏 单位名称 地址 详细地址 性质 和行业分类 -->
                  <div
                    class="form-item underline-un-focus"
                    :class="{'textarea': field.elementType === 'TEXTAREA'}"
                  >
                    <nd-choose
                      v-if="field.elementType === 'SELECT'"
                      :name="field.fieldId"
                      v-model="form[field.fieldId]"
                      :data="field.valueRange"
                      :valueKey="['key', 'value']"
                      :label="field.chineseName"
                      :placeholder="`请选择`"
                      text-align="right"
                      @change="handleChooseChange"
                    >
                    </nd-choose>
                    <template>
                      <nd-input
                        v-if="field.elementType === 'INPUT'"
                        :name="field.fieldId"
                        v-model="form[field.fieldId]"
                        :label="field.chineseName"
                        :placeholder="field.placeholder||`必填`"
                        text-align="right"
                        :maxLength="String(field.maxLength)"
                      >
                      </nd-input>
                    </template>
                    <nd-address
                      v-if="field.elementType === 'AREA'"
                      :name="field.fieldId"
                      v-model="form[field.fieldId]"
                      :key="field.fieldId"
                      :columns="3"
                      :mutilple="true"
                      inputStyle="width: 70%;margin-left: 30%"
                      :label="field.chineseName"
                      @open="openAddress"
                      @close="closeAddress"
                      @change="addressChange"
                      @scroll="addressScroll"
                      v-show=" !(['f18'].includes(field.fieldId) && ['H','G','A'].includes(form['f5']))"
                    >
                    </nd-address>
                    <nd-input
                      v-if="field.elementType === 'TEXTAREA' "
                      type="textarea"
                      :name="field.fieldId"
                      :autoSize="false"
                      :rows="1"
                      v-model="form[field.fieldId]"
                      text-align="right"
                      :placeholder="field.placeholder||`必填`"
                      @blur="addressBlur"
                      @focus="addressFocus"
                      @input="addressInput"
                      :maxLength="String(field.maxLength)"
                    >
                    </nd-input>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </form>

      </main>
      <footer class="footer">
        <nd-button class="btn " @click="submitBaseInfo" :loading="pedding" >
          <template v-if="stepType==='BASE'">提交</template>
          <template v-else-if="showFace">补充人脸信息</template>
          <template v-else>提交资料，立获额度</template>
        </nd-button>
      </footer>
    </template>

    <detention-dialog
      v-model="detentionVisible"
      @on-close="detentionVisible=false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validateNew from '@/components/nd-validate/validateNew'
import { getKey } from '@/assets/utils'
import _ from 'lodash'

export default {
  name: 'apiAuth',
  mixins: [validateNew],
  components: {
    detentionDialog: () => import('./components/detention-dialog.vue'),
    ocr: () => import('./components/ocr.vue')
  },
  data () {
    return {
      detentionVisible: false, 
      allData: [],
      form: {
        f18: ''
      },
      rules: {},
      baseInfo: {
        ocrRecord: {},
        authStatus: []
      },
      orcConfig: [],
      dict: {},
      faceConfig: [],
      pedding: false,
      /**
       * ALL 授信补充资料 由结果页跳入
       * OCR 由补充资料首页进入 只补充OCR
       * BASE 由补充资料首页进入 只补充资料
       */
      stepType: 'ALL'
    }
  },
  async mounted () {
    this.stepType = this.$route.query.stepType || 'ALL'
    try {
      const configIds = getKey('configIds')
      await this.getUserInfo()
      this.init(configIds)
      this.$bus.$emit('ready')
    } catch (e) {
      this.$bus.$emit('ready')
    }
  },
  computed: {
    showFace () {
      return !this.baseInfo.authStatus.includes('LIVENESS') && this.faceConfig.length > 0
    },
    ocrStatus () {
      if (this.baseInfo.authStatus.includes('OCR_EXPIRE')) {
        return 'expired'
      } else {
        return 'ocr'
      }
    },
    showOcr () {
      // 三个资料合并成一个之后不用做修改 1026
      return !this.baseInfo.authStatus.includes('OCR') || this.baseInfo.authStatus.includes('OCR_EXPIRE')
    },
    cData () {
      if (!['H', 'G', 'A'].includes(this.form['f5'])) {
        this.$nextTick(() => {
          this.validator(this.$refs.form, this.renderRules())
        })
        return this.allData || [] 
      } else {
        const _data = _.cloneDeep(this.allData)
        _data.map((item, index) => {
          if (index === 0) {
            item.fieldDefs = item.fieldDefs.filter(i => {
              return !['f13', 'f15', 'f16', 'f17', 'f18'].includes(i.fieldId)
            })
            item.fieldDefs.forEach(i => {
              if (['f5'].includes(i.fieldId)) {
                i.valueRange = i.valueRange.filter(i => {
                  return !['H', 'G', 'A'].filter(key => key !== this.form['f5']).includes(i.key)
                })
              }
            })
          }
        })
        this.$nextTick(() => {
          this.validator(this.$refs.form, this.renderRules())
        })
        return _data || []
      }
    }
  },
  methods: {
    ...mapActions('apiDiversion', ['getFieldConfigX', 'userBaseInfo', 'saveBaseInfo', 'saveBaseInfoBoth', 'creditApply']),
    renderRules () {
      const rules = {}
      if (['H', 'G', 'A'].includes(this.form['f5'])) {
        Object.keys(this.rules).forEach(item => {
          if (!['f13', 'f15', 'f16', 'f17', 'f18'].includes(item)) {
            rules[item] = this.rules[item]
          }
        }) 
        return rules
      }
      return this.rules
    },
   
    async init (configIds) {
      if (this.stepType === 'OCR') return
      const quickConfig = await this.getFieldConfigX({
        configIds
      })

      let arr = quickConfig.data.defCollections
      this.allData = arr.filter(item => !['R', 'F'].includes(item.colName))
      this.orcConfig = arr.filter(item => item.colName === 'R')
      this.faceConfig = arr.filter(item => item.colName === 'F')
      this.allData.forEach(item => {
        item.fieldDefs.map(ele => {
          this.dict[ele.fieldId] = ele.fieldName
          // 自由职业 禁用 当新数据或者没有选择自由职业就删除此选项
          if (ele.fieldName === 'occupations' && !['H', 'G', 'A'].includes(this.form['f5'])) {
            ele.valueRange = ele.valueRange.filter(i => {
              return !['H', 'G', 'A'].includes(i.key)
            })
            // ele.valueRange.forEach(i => {
            //   if (['H'].includes(i.key)) {
            //     i.disabled = 'Y'
            //   }
            // })
          }
          // 设置回显的值
          // this.$set(this.form, ele.fieldName, ele.value)
          // 设置校验规则
          const _rule = ele.checkDefinations || []
          const rules = _rule.map(rule => {
            const newRule = {
              message: rule.toast
            }
            if (rule.require) {
              newRule.require = true
            } else {
              if (rule.checkType === 'REG') {
                newRule.regular = new RegExp(rule.checkRule)
              }
            }
            return newRule
          })
          this.$set(this.rules, ele.fieldId, rules)
        })
      })
      // 因为配置从接口获取，这里必定会比mounted晚，所以在rules配置完成后执行一下validator方法
     
      this.$nextTick(() => {
        this.validator(this.$refs.form, this.renderRules())
      })

      // this.form = {
      //   f10: 'T',
      //   f11: '姓名发',
      //   f12: '13222222222',
      //   f13: '水岸东方公司',
      //   f2: 'C',
      //   f3: 'S',
      //   f4: 'D',
      //   f5: 'B',
      //   f6: '重庆市 重庆市 北碚区 500000 500100 500109',
      //   f7: 'B',
      //   f8: '姓名是',
      //   f9: '13333333333',
      //   f14: '测试详细地址'
      // }
    },
    async getUserInfo () {
      const { success, data } = await this.userBaseInfo({
        queryType: 'detail'
      })
      if (success) {
        this.baseInfo = data
        // 回填信息
        const { address, area, areaCode, city, cityCode, corpName, education, marital, occupations, province, provinceCode, salaries, companyProvinceDesc, companyCityDesc, companyAreaDesc, companyProvinceCode, companyCityCode, companyAreaCode, companyAddress, natureUnit, industryUnit } = data.userDetail || {}
        this.form = {
          f2: education,
          f3: marital,
          f4: salaries,
          f5: occupations,
          f6: [province, city, area, provinceCode, cityCode, areaCode].join(' '),
          f13: corpName, // 公司名称
          f14: address, 
          f15: companyAddress, // 详细地址
          f16: natureUnit, // 单位性质
          f17: industryUnit// 单位所属行业
        }
        if (companyProvinceDesc) {
          this.form.f18 = [companyProvinceDesc, companyCityDesc, companyAreaDesc, companyProvinceCode, companyCityCode, companyAreaCode].join(' ')
        }
       
        // 联系人1
        if (data.contacts && data.contacts.length) {
          const { contactName, mobileNumber, relation } = data.contacts[0]
          this.form.f7 = relation
          this.form.f8 = contactName
          this.form.f9 = mobileNumber
        }
        // 联系人2
        if (data.contacts && data.contacts.length && data.contacts.length > 1) {
          const { contactName, mobileNumber, relation } = data.contacts[1]
          this.form.f10 = relation
          this.form.f11 = contactName
          this.form.f12 = mobileNumber
        }
      }
    },
    // 提交资料
    async submitBaseInfo () {
      const valid = this.validate(this.$refs.form, this.renderRules())
      if (!valid) return
      // 不是base的情况都去做一次ocr

      try {
        if (this.showOcr) {
          await this.$refs.ocrRef.next()
          if (this.stepType === 'OCR') return
        }
        
        const configIds = getKey('configIds')
        const params = { 
          configIds
        }
       
        this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: JSON.stringify(configIds), page_status: JSON.stringify(this.baseInfo.authStatus) })
        const contactList = []
        Object.keys(this.form).forEach((key) => {
          if (!['f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12'].includes(key)) {
            params[this.dict[key]] = this.form[key]
          }
        })
        // 渲染省市区
        const { f6, f7, f8, f9, f10, f11, f12, f18 } = this.form
        if (f6) {
          const [province, city, area, provinceCode, cityCode, areaCode] = f6.split(' ')
          params['province'] = province
          params['city'] = city
          params['area'] = area
          params['provinceCode'] = provinceCode
          params['cityCode'] = cityCode
          params['areaCode'] = areaCode
        }
        // 解析联系人1
        if (f7) {
          contactList.push({
            relation: f7,
            name: f8,
            mobile: f9

          })
        }
        // 解析联系人2
        if (f10) {
          contactList.push({
            relation: f10,
            name: f11,
            mobile: f12
          })
        }
        if (contactList.length) {
          params.contactList = contactList
        }

        if (f9 && f12) {
          if (f9 === f12) {
            this.$message('联系人重复，请重新输入')
            return
          }
          if ([f9, f12].includes(this.baseInfo.mobile)) {
            this.$message('本人不能为联系人，请重新输入')
            return
          }
        }

        // 单位地址
        if (f18) {
          const [province, city, area, provinceCode, cityCode, areaCode] = f18.split(' ')
          params['companyProvinceDesc'] = province
          params['companyCityDesc'] = city
          params['companyAreaDesc'] = area
          params['companyProvinceCode'] = provinceCode
          params['companyCityCode'] = cityCode
          params['companyAreaCode'] = areaCode
        }

        // 缓存用户基本信息
        // this.cacheBaseInfo(this.form)

        let response = null
      
        this.pedding = true

  
        // 上报设备信息 如果不成功则阻断
        const { data } = await this.sendDataForThird()
        if (!data.success) {
          this.pedding = false
        }
    
        response = await this.saveBaseInfo(params)
        // response = await this.saveBaseInfoBoth(params)
        this.pedding = false
        if (response.success) {
          if (this.stepType === 'BASE') {
            return this.$router.replace('/authentication/api-auth')
          } else {
            // 判断是否已经做过人脸
            if (this.showFace) {
              return this.$router.replace(`/authentication/face?to=${configIds.length > 1 ? 'riverDiversion' : 'apiAuthResult'}`)
            }
            // 一个产品的时候跳转授信结果页 多个的时候跳转导流主页 已申请列表
            const res = await this.creditApply({
              configIds
            })
            if (!res.success) {
            
            }
            if (configIds.length > 1) {
              this.$router.replace('/river/diversion?tabActive=1')
            } else {
              this.$router.replace({ 
                path: '/authentication/api-result',
                query: {
                  applyNo: res.data.applyNo
                }
              })
            }
          }
        }  
      } catch (error) {
        console.log(error)
      }
    },

    // 根据选择框判断是否显示输入框
    isShow (ele, list) {
      if (!ele.cascadeFields) return true
      /**
       * 当前field需要关联的field的id、value和show
       */
      const relationFieldId = ele.cascadeFields[0].fieldId
      const relationFieldValue = ele.cascadeFields[0].fieldValue
      const relationShow = ele.cascadeFields[0].isShow


      
      // 找到fieldId对应的field
      const relationField = list.find(data => {
        return data.fieldId === relationFieldId
      })

      // 查看field的值是否在relationFieldValue中
      const isIncludesValue = relationFieldValue.includes(this.form[relationField && relationField.fieldId])
      const isShow = relationShow ? isIncludesValue : !isIncludesValue
      /**
       * 由于错误提示的dom是在initValidateFormItem方法后生成的
       * 所以这里切换了dom的显示后，应该重新调用一下initValidateFormItem方法
       */
      if (isShow) {
        this.$nextTick(() => {
          const node = this.$refs.form.querySelector(`[name="${ele.fieldId}"]`)
          this.initValidateFormItem(node, ele.fieldId, this.rules)
        })
      }
      return isShow
    },
    handleChooseChange (text, fieldId) {
      if (text) this.removeValidateField(this.$refs.form, this.rules, fieldId)
    },
    occupationChange (data) {
      this.currentOccupationData = data
    },

    occupationScroll () {},

    maritalChange (data) {},

    maritalScroll () {},

    addressChange (data, fieldId) {
      if (data) this.removeValidateField(this.$refs.form, this.rules, fieldId)
      this.$forceUpdate()
    },

    addressScroll () {},

    // IOS键盘弹出时会触发focusin事件
    iosFocusIn () {},

    // IOS键盘收起时会触发focusout事件
    iosFocusOut () {},

    // 安卓手机键盘弹出和收起时多半都会触发resize事件
    androidWindowResize () {
      var thisHeight = document.documentElement.clientHeight
      if (this.winHeight - thisHeight > 100) {
        this.winHeight = thisHeight
      } else if (this.winHeight - thisHeight < -100) {
        this.winHeight = thisHeight
      }
    },
            
    // 现居住地获得焦点
    addressFocus () {},

    // 现居住地失去焦点
    addressBlur () {},

    // 现居住地内容发生变化
    addressInput (target) {},

    // 单位名称获取焦点
    corpNameFocus () {},

    // 单位名称失去焦点
    corpNameBlur () {},

    // 单位名称内容发生变化
    corpNameInput (target) {},

    // 单位电话获得焦点
    corpPhoneFocus () {},

    // 单位电话失去焦点
    corpPhoneBlur () {},

    // 单位电话内容发生变化
    corpPhoneInput (target) {},

    // 单位地址获得焦点
    corpAddressFocus () {},

    // 单位地址失去焦点
    corpAddressBlur () {},

    // 单位地址内容发生变化
    corpAddressInput (target) {},

    // 选择职业 - 下拉框弹出
    openOccupation () {},

    // 选择职业 - 下拉框收起
    closeOccupation () {},

    // 选择婚姻状况-下拉框弹出
    openMarital () {},

    // 选择婚姻状况-下拉框收起
    closeMarital () {},

    // 选择现居住地-下拉框弹出
    openAddress () {},

    // 选择现居住地-下拉框收起
    closeAddress () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.api-auth {
  background: #f7f7f7;
  min-height: 100vh;

  /deep/ .page {
    width: 750px;
 
  }

  .title {
    padding: 32px 40px;
    margin-top: 30px;
    h1 {
      font-size: 46px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      height: 65px;
      line-height: 65px;
      color: @fc1;
      position: relative;

      img {
        width: 56px;
        position: absolute;
        bottom: 7px;
      }

      span {
        margin-left: 76px;
      }
    }

    h2 {
      margin-top: 17px;
      font-size: 28px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
    }
  }

  .form {
    .card-title {
      height: 45px;
      line-height: 45px;
      margin: 75px 40px 23px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      position: relative;

      img {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 0;
      }

      span {
        margin-left: 56px;
      }
    }

    .card-panel {
      background-color: white;

      .form-item {
        height: 110px;
        line-height: 110px;
        padding: 0 40px;
        margin-top: 0;
        // .form-tip{
        //     top: 65%;
        // }
        .input-cover {
          position: absolute;
          left: 40px;
          right: 40px;
          z-index: 1;
          height: 100%;
        }

        &.textarea {
          height: 80px;
          .nd-input {
            margin-top: 40px;
            line-height: 1.4em;
          }
        }

        .nd-select,
        .nd-input,
        .nd-choose,
        .nd-address {
          label {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          input {
            font-size: 30px;
          }

          textarea {
            font-size: 30px;
          }
        }

        .nd-input {
          .nd-input-inner {
            line-height: 1.4em;
          }
        }
      }
    }
  }

  .main-product {
    width: 690px;
    height: 320px;
    background: #ffffff;
    border-radius: 20px;
    margin: 30px auto;
    padding: 30px;

    .header {
      display: flex;
      height: 90px;
      align-items: center;
      border-bottom: 1px solid #eee;
      img {
        width: 48px;
        height: 48px;
        margin-right: 10px;
      }
      .name {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .info {
        flex: 1;
        font-size: 20px;
        text-align: right;
        .danger {
          color: #ff4633;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      padding: 10px 0;
      height: 180px;
      justify-content: space-around;
      .name {
        font-size: 24px;
      }
      .amount {
        font-size: 40px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
      }
      .exp {
        color: #999;
        font-size: 24px;
      }
    }
  }
  .task-list {
    border-radius: 20px;
    overflow: hidden;
    margin: 0 30px;
    .success {
      color: #aaa;
    }
    .wait {
      color: #8eb2d8;
    }
    .nd-cell {
      border-bottom: 1px solid #eee;
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    padding: 90px 0;
    align-items: center;
    width: 100%;
    .xie-yi {
      color: #333;
      font-size: 22px;
      padding-bottom: 30px;
      a {
        color: #8eb2d8;
      }
    }
  }
}
</style>
